import { PageEvent } from '@angular/material/paginator';
import { ErrorResponse } from './../../models/error.model';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilsService } from './../../services/utils.service';
import { NotificationsService } from './../../services/notifications.service';
import { PaginatorStatus, DataTableColumn, MenuButton } from './../generics/data-table/data-table.component';
import { Component, OnInit } from '@angular/core';
import { Notification } from 'src/app/models/notification.model';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Fecha', prop: 'fechaCreacion', type: 'datetime' },
        { name: 'Fecha de lectura', prop: 'fechaLectura', parseValue: date => date ? this.utilsService.beautifyDate(date, 'L HH:mm') : 'No leida' },
        { name: 'Título', prop: 'titulo' },
        { name: 'Contenido', prop: 'contenido' },
    ];

    menuButtons: MenuButton<Notification>[] = [
        { label: 'Ver detalles', action: notification => this.router.navigate([notification.id], { relativeTo: this.route }) }
    ];

    notifications: Notification[];

    constructor(
        private notificationsService: NotificationsService,
        private utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.getNotifications();
    }

    getNotifications() {
        this.notificationsService.getNotifications(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, true)
        .subscribe(response => {
            this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
            this.notifications = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener notificaciones', error.error?.descripcion));
    }

    updateNotifications(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getNotifications();
    }
}
